import {
  formatCurrency,
  defaultDateDisplay,
  defaultDateOnlyDisplay,
  jounralStatusMap,
} from "../../../helpers";
import styles from "./styles.module.scss";
import JournalLineTable from "./JournalLineTable";
import secondaryComponents from "../../secondaryComponents";
import primaryComponents from "../../primaryComponents";
import useGetPermission from "../../../hooks/useGetPermission";
import useJournalEntryDetails from "./useJournalEntryDetails";

const JournalEntryDetails = ({
  journalEntryDetails,
  refetchJournalEntryDetails,
}) => {
  const {
    approveJournalEntryMutation,
    declineJournalEntryMutation,
    voidJournalEntryMutation,
    copyJournalEntryMutation,
    handleApproveJournalEntry,
    handleDeclineJournalEntry,
    handleVoidJournalEntry,
    handleCopyJournalEntry,
  } = useJournalEntryDetails({
    reference: journalEntryDetails?.reference,
    refetchJournalEntryDetails,
  });
  const { isPermitted: canPostOrApproveJournal } = useGetPermission({
    permissionParentKey: "Accounting",
    permissionChildKey: "can_post_or_approve_journal_entry",
  });

  return (
    <div className={styles.journalEntryDetails}>
      <div className={styles.journalEntryDetails__card}>
        <div className={styles.journalEntryDetails__card__header}>
          <span
            className={`${jounralStatusMap[journalEntryDetails?.status]} text-capitalize font-weight-bold`}
          >
            {journalEntryDetails?.status_label}
          </span>
          <div>
            <secondaryComponents.JournalOptionsDropdown
              copyJournalEntry={handleCopyJournalEntry}
              copyJournalEntryMutation={copyJournalEntryMutation}
              voidJournalEntry={handleVoidJournalEntry}
              voidJournalEntryMutation={voidJournalEntryMutation}
              journalEntryDetails={journalEntryDetails}
            />
          </div>
        </div>
        <div className={styles.journalEntryDetails__card__body}>
          <div>
            <p>Narration</p>
            <h5>{journalEntryDetails?.description}</h5>
          </div>
          <div>
            <p>TAX Type</p>
            <h5>{journalEntryDetails?.tax_type_label}</h5>
          </div>
          <div>
            <p>Journal Date</p>
            <h5>{defaultDateOnlyDisplay(journalEntryDetails?.entry_date)}</h5>
          </div>
          <div>
            <p>Created By</p>
            <h5>
              {journalEntryDetails?.initiated_by?.first_name}{" "}
              {journalEntryDetails?.initiated_by?.last_name}
            </h5>
          </div>
          <div>
            <p>Approved By</p>
            <h5>
              {journalEntryDetails?.initiated_by?.first_name}{" "}
              {journalEntryDetails?.initiated_by?.last_name}
            </h5>
          </div>
          <div>
            <p>Entry Type</p>
            <h5>{journalEntryDetails?.entry_type_label}</h5>
          </div>
          <div>
            <p>Source</p>
            <h5>{journalEntryDetails?.source_label || "-"}</h5>
          </div>
          <div>
            <p>Store</p>
            <h5>{journalEntryDetails?.store?.name || "-"}</h5>
          </div>
          <div>
            <p>Created On</p>
            <h5>{defaultDateDisplay(journalEntryDetails?.created_at)}</h5>
          </div>
          <div>
            <p>Linked Transaction</p>
            <h5>{journalEntryDetails?.entity_reference || ""}</h5>
          </div>
        </div>
        <div className={styles.journalEntryDetails__card__lines}>
          <h5>Entry Lines</h5>
          <div className={styles.lineCardSession}>
            <JournalLineTable journalEntryDetails={journalEntryDetails} />
            <div className={`${styles.summary}`}>
              <table>
                <tbody>
                  <tr>
                    <td style={{ padding: "5px" }}>Total</td>
                    <td>
                      {formatCurrency({
                        value: journalEntryDetails.total_debit,
                        currencyCode: journalEntryDetails?.currency_code,
                      })}
                    </td>
                    <td>
                      {formatCurrency({
                        value: journalEntryDetails.total_credit,
                        currencyCode: journalEntryDetails?.currency_code,
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {journalEntryDetails.status === "IN_REVIEW" &&
          canPostOrApproveJournal && (
            <div className={`${styles.reviewActions}`}>
              <primaryComponents.Button
                classNames={"btn btn--outline-red"}
                onClick={handleDeclineJournalEntry}
                isLoading={declineJournalEntryMutation.isLoading}
                isDisabled={
                  approveJournalEntryMutation.isLoading ||
                  declineJournalEntryMutation.isLoading ||
                  voidJournalEntryMutation.isLoading
                }
                loadingText="Declining..."
                style={{ marginTop: "20px" }}
              >
                Cancel Journal Entry
              </primaryComponents.Button>
              <primaryComponents.Button
                classNames={"btn btn--primary"}
                onClick={handleApproveJournalEntry}
                isLoading={approveJournalEntryMutation.isLoading}
                isDisabled={
                  approveJournalEntryMutation.isLoading ||
                  declineJournalEntryMutation.isLoading ||
                  voidJournalEntryMutation.isLoading
                }
                loadingText="Approving..."
                style={{ marginTop: "20px" }}
              >
                Approve Journal Entry
              </primaryComponents.Button>
            </div>
          )}
      </div>
    </div>
  );
};

export default JournalEntryDetails;
